<template>
  <va-edit-layout :actions="['list', 'show', 'delete']">
    <properties-form :id="id" :title="title" :item="item"></properties-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ['id', 'title', 'item'],
}
</script>
